export class StatisticsAggregate {
  private startTime_ = 0
  private sum_ = 0
  private count_ = 0
  private max_ = 0
  private rampUpTime_ = Infinity
  private rampUpThreshold_ = 0

  constructor(rampUpThreshold = 0) {
    this.rampUpThreshold_ = rampUpThreshold
  }

  add(time: number, datapoint: number) {
    if (this.startTime_ === 0) {
      this.startTime_ = time
    }
    this.sum_ += datapoint
    this.max_ = Math.max(this.max_, datapoint)
    if (this.rampUpTime_ === Infinity && datapoint > this.rampUpThreshold_) {
      this.rampUpTime_ = time
    }
    this.count_++
  }

  getAverage() {
    if (this.count_ === 0) {
      return 0
    }
    return Math.round(this.sum_ / this.count_)
  }

  getMax() {
    return this.max_
  }

  getRampUpTime() {
    return Math.round(this.rampUpTime_ - this.startTime_)
  }
}

export const round = (int: number) => {
  return (Math.round(int * 100) / 100).toFixed(2)
}

export const now = () => {
  return performance.timeOrigin + performance.now()
}

const byteUnits = [
  ' kbps',
  ' Mbps',
  ' Gbps',
  ' Tbps',
  'Pbps',
  'Ebps',
  'Zbps',
  'Ybps',
]

export const getReadableSizeString = (fileSizeInBytes: number) => {
  let i = -1
  do {
    fileSizeInBytes = fileSizeInBytes / 1024
    i++
  } while (fileSizeInBytes > 1024)

  return Math.max(fileSizeInBytes, 0.1).toFixed(2) + byteUnits[i]
}
